<template>
  <div class="template">
    <LobbyZoomParams />
    <LoaderFullPage v-if="store.loading" />
    <LobbyZoomDatas v-else />
  </div>
</template>

<script setup>
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import LobbyZoomParams from "@follaw-fr/components/lobbies/organisms/LobbyZoomParams.vue";
import LobbyZoomDatas from "@follaw-fr/components/lobbies/organisms/LobbyZoomDatas.vue";
import { useLobbiesStore } from "@follaw-fr/stores/lobbies.js";
import { useRoute } from "vue-router";
const route = useRoute();
const store = useLobbiesStore();

if (store.lobbyZoom?.national_id !== route.params._id) {
  store.readOneLobby(route.params._id);
}
</script>
